<template>
    <ModalWrapper
        v-model="dialog"
        hide-cancel
        transition="dialog-center-transition"
        :subtitle="$t('check_the_columns')"
        :fullscreen="$breakpoint.smAndDown"
        scrollable
    >
        <template v-slot:activator="{props}">
            <v-btn
                :disabled="isTableOptionsLoading"
                color="primary"
                variant="text"
                icon="mdi-circle-edit-outline"
                v-bind="props"
                data-cy="show-modal"
                @click="dialog = true"
            />
        </template>
        <template v-slot:title>
            {{ title }}
        </template>
        <template v-slot:content>
            <template v-for="checkbox in checkboxes" :key="checkbox.value">
                <v-checkbox
                    v-if="!fixedColumnsNames.includes(checkbox.value)"
                    v-model="checkbox.show"
                    :label="checkbox.title"
                    density="compact"
                    color="primary"
                    hide-details
                    :data-cy="`column-${checkbox.value}`"
                />
            </template>
        </template>
        <template v-slot:btns>
            <v-btn data-cy="close-modal" color="inherit" variant="text" @click="closeModal">
                {{ $t('cancel') }}
            </v-btn>
            <v-btn
                data-cy="save"
                :loading="isTableOptionsLoading"
                :disabled="isTableOptionsLoading"
                variant="flat"
                @click="save"
            >
                {{ $t('save') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import {clone} from '@/utils/helpers'
    import type {TableHeadersType} from '~/utils/types/types'

    @Component({
        components: {},
    })
    export class TableOptionsModal extends Vue {
        @Prop({default: [], required: true}) tableColumns: TableHeadersType
        @Prop({default: []}) fixedColumnsNames: string[]
        @Prop({required: true, type: String}) title: string
        @Prop({default: false, required: true, type: Boolean}) isTableOptionsLoading: boolean
        @Watch('tableColumns', {immediate: true})
        onLocaleChange(): void {
            this.checkboxes = clone(this.tableColumns)
        }

        dialog: boolean = false
        checkboxes: TableHeadersType = []

        closeModal(): void {
            this.dialog = false
            this.checkboxes = clone(this.tableColumns)
        }

        save(): void {
            const hiddenColumns: string[] = this.checkboxes.filter(({show}) => !show).map(({value}) => value)
            this.$emit('changeTableOptions', hiddenColumns)
        }
    }

    export default TableOptionsModal
</script>
